import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    worstRatedHeader: {
        ...theme.typography.h5,
        color: theme.palette.text.secondary,
        display: 'flex',
        justifyContent: "center"
    },
    worstRatedContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: "center",
        paddingTop: 10,
        paddingBottom: 10
    },
    worstRatedRow: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: "100%",
        padding: 5
    },
    worstRatedSummaryValue: {
        color: theme.palette.text.secondary,
        width: "15%",
        textAlign: "center",
        fontWeight: "bold",
        fontSize: 18
    },
    worstRatedSummaryContent: {
        color: theme.palette.text.secondary,
        width: "85%"
    },
    moreWorstRatedScoredScenesButton: {
        width: "100%",
    },
    moreWorstRatedScoredScenesButtonContainer: {
        padding: 5
    },
}));

export {useStyles};